/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('popup.security-manager', ['popup', 'data.user', 'data.security-manager']);
